import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

type Props = {
  open: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
};

export const SignOutConfirmationDialog = ({
  open,
  handleClose,
  handleConfirm,
}: Props) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="signout-dialog-title"
      aria-describedby="signout-dialog-description"
    >
      <DialogTitle id="signout-dialog-title">
        {t('LogoutConfirmationHeader')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="signout-dialog-description">
          {t('LogoutConfirmationBody')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose}>
          {t('Cancel')}
        </Button>
        <Button variant="contained" color="error" onClick={handleConfirm}>
          {t('LogOut')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
